import commonStyle from "./common.module.css"
import radioStyle from "./radio.module.css";


export default function Radio(props) {

    const label = props['label']
    const name = props['name']
    const list = props['list']
    const required = props['required']
    const error = props['error']
    const event = props['event']

    return(
        <div className={commonStyle['wrap']}>
            <input
                type="text"
                category="field"
                name={name}
                required={required === true ? true : false}
                style={{
                    display: "none"
                }}
                readOnly={true}
                error={error}
            ></input>

            {label &&
                <label
                    className={required === true ? commonStyle['required'] : null}
                >{label}</label>
            }

            <div className={commonStyle['field']}>
                {list
                .map((value, index) => {
                    return (
                        <label
                            key={index}
                            className={radioStyle['radio']}
                        >
                            <input
                                type="radio"
                                name={name}
                                value={value['value']}
                                onClick={(e) => {
                                    document.querySelector(`[name="${name}"][category="field"]`).value = e.currentTarget.value
                                }}
                                {...event}
                            ></input>
                            <div>{value["name"]}</div>
                        </label>
                    );
                })}
            </div>

            {error &&
                <span
                    className={commonStyle['error']}
                >{error}</span>
            }
        </div>
    );
}
